// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';

// material ui
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

// relative
import useUrlViewMode from '../../hooks/useUrlViewMode';

export function AnalysisViewToggleButtonGroup() {
  const { t } = useTranslation('energyxplorer-analysis-tabs');
  const [viewMode, setViewMode] = useUrlViewMode({
    allowed: ['column', 'box', 'line'],
    fallback: 'column',
  });

  return (
    <ToggleButtonGroup
      className="non-printable"
      value={viewMode}
      exclusive
      size="small"
      onChange={(event, newView) => {
        if (newView !== null) {
          setViewMode(newView);
        }
      }}
    >
      <ToggleButton value="line">
        <ShowChartRoundedIcon fontSize="small" sx={{ mr: 1 }} />
        {t('consumption_analysis.view_as_line')}
      </ToggleButton>

      <ToggleButton value="column">
        <BarChartRoundedIcon fontSize="small" sx={{ mr: 1 }} />
        {t('consumption_analysis.view_as_column')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
